
import {defineStore} from 'pinia';
var project_name = process.env.VUE_APP_PROJECT_NAME;
const token_local_storage_key = project_name + "_jwt_token";
const user_local_storage_key = project_name + "_user";
const users_local_storage_key = project_name + "_stored_users";

const sessionToken = localStorage.getItem(token_local_storage_key) || false;
const userLoaded = localStorage.getItem(user_local_storage_key);
const usersLoaded = localStorage.getItem(users_local_storage_key);

export const useSecurityStore = defineStore('security', {
    state: () => ({
        token: sessionToken,        
        loading: false,
        errors: [],
        logoutmessage: null,
        user: userLoaded? JSON.parse(userLoaded) : false,
        storedusers: usersLoaded? JSON.parse(usersLoaded): { },
    }), 

    actions: {
        setUser(user){
            localStorage.setItem(user_local_storage_key, JSON.stringify(user));
            this.user = user;
        },
        addStoredUser(user){
            this.storedusers[user.Id ?? user.IdentificationNumber] = user;
            localStorage.setItem(users_local_storage_key, JSON.stringify(this.storedusers));
        },
        removeStoredUser(user){
            delete this.storedusers[user.Id ?? user.IdentificationNumber];
            localStorage.setItem(users_local_storage_key, JSON.stringify(this.storedusers));
        },
        setToken(token)
        {            
            try{
                this.decodeToken(token);
                localStorage.setItem(token_local_storage_key, token);
                this.token = token;
            }
            catch{                
                localStorage.removeItem(token_local_storage_key);
                this.token = false;
            }                
        },        
        decodeToken(token)
        {
            var base64Url = token.split('.')[ 1 ];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c)
            {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
    
            return JSON.parse(jsonPayload);
        },
        logout(message){
            this.logoutmessage = message;
            localStorage.removeItem(user_local_storage_key);
            localStorage.removeItem(token_local_storage_key);
            this.token = false;
            this.user = false;
        },
        setLogoutMessage(message){
            this.logoutmessage = message;
        },
    }    
})
